import Api from "~/service/Api";

class AwsS3ListPartRepository {
  fetch(query) {
    return Api.get("/aws-s3/list-parts", query);
  }
}

export default AwsS3ListPartRepository;
